import { useStaticQuery, useStaticMutation } from '../../../helpers/useStaticData';
import { getRoomsResponse } from '../../../helpers/data';

export const useGetRoomQuery = () => useStaticQuery(() => getRoomsResponse());

export const useAddRateMutation = () => useStaticMutation();

export const useAddLikeMutation = () => useStaticMutation();

export const useDeleteRoomLikeMutation = () => useStaticMutation();

export const useGetRateQuery = () => useStaticQuery(() => ({ data: [] }));
